import styled from "styled-components";

export const TimeSelectStyled = styled.div`
  .time_select {
    border-radius: 20px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    padding: 0 15px;
    width: 250px;
    height: 40px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
 .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  .theme_standard {
  }
`;
